import Axios from 'axios';
import {
    Column,
    FilterRow,
    Paging,
    Scrolling,
    Summary,
    TotalItem
} from 'devextreme-react/data-grid';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import DatagridCustom from '../../../../components/common/datagrid/custom-datagrid';
import { goRiceUrl } from '../../../../constant/siteConstants';
import getConfigToken from '../../../../utils/getConfigToken';
import { formatMoney } from '../../../../utils/NumberFormat';
import useFormatMessage from '../../../../utils/useFormatMessage';
import EmployeeUpdateModal from './EmployeeUpdateModal';

export default function EmployeeTable({ dataSource, trigger, setTrigger, dataGridRef }) {
    const { t } = useFormatMessage();
    const notifySuccess = (message) => toast.success(`${message}`);
    const notifyError = (message) => toast.error(`${message}`);

    const [modalUpdate, setModalUpdate] = useState(false);
    const [modalDelete, setModalDelete] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState()
    const [employeeDetail, setSelectedRow] = useState({
        EmployeeId: 0,
        Email: "",
        FullName: "",
        UserName: "",
        Cinsiyet: "",
        IsActive: false,
        Password: "",
        RedirectPath: "",
        warehouse_id: null,
    })
    async function getEmployeeById(employeeId) {
        await Axios.post(`${goRiceUrl}/api/employee/getByEmployeeID`, { "employee_id": employeeId }, getConfigToken).then((resp) => {
            if (resp.status === 200) {
                setSelectedRow(resp.data);
                setModalUpdate(true)
            } else {
                notifyError("Çalışan verileri yüklenirken bir hata meydana geldi.");
            }
        }).then(() => {
            setTimeout(() => {
                //getSelectedUserData();
            }, 500);
        }).catch((err) => {
            console.error(err);
            notifyError("Çalışan verileri yüklenirken bir servis hatası meydana geldi.");
        })
    }

    function settingsCell(data) {
        return (
            <Row className="d-flex justify-content-around">
                <Col lg="3" className="d-flex justify-content-center">
                    <i className='fa fa-edit mt-2' onClick={() => { setSelectedUserId(data.data.employee_id); getEmployeeById(data.data.employee_id); }} style={{ fontSize: "18px", cursor: "pointer", color: "blue" }}></i>
                </Col>
                <Col lg="3" className="d-flex justify-content-center">
                    <i className='fa fa-trash mt-2' onClick={() => { setSelectedUserId(data.data.employee_id); setModalDelete(true); }} style={{ fontSize: "18px", cursor: "pointer", color: "blue" }}></i>
                </Col>
            </Row>
        )
    }

    function deleteEmployee(id) {
        Axios.post(goRiceUrl + `/api/employee/delete`, {
            employee_id: id,
            user_id: parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
        }, getConfigToken).then((resp) => {
            notifySuccess("Kullanıcı kaydı başarıyla silindi.")
            // setTimeout(() => {
            //     document.getElementById("saveButtonNew").disabled = false
            // }, 1500);
            setModalDelete(false);
            setTrigger(!trigger);
        }).catch((err) => {
            console.error(err);
            notifyError("Kullanıcı kaydı silinirken servis hatası meydana geldi.");
        })
    }

    return (
        <>
            <DatagridCustom
                dataSource={dataSource}
                // onExporting={onExporting}
                height={520}
                reff={dataGridRef}
            >
                <Scrolling columnRenderingMode="virtual" />
                <Paging enabled={false} />
                {/* <Export enabled={true} /> */}
                <FilterRow visible={true} />
                {/* <Column dataField="SicilNo" selectedFilterOperation={"contains"} caption="Sicil No" alignment="center" /> */}
                <Column dataField="full_name" selectedFilterOperation={"contains"} caption={t("Ad Soyad")} alignment="center" />
                <Column dataField="email" selectedFilterOperation={"contains"} caption={t("Kullanıcı Adı")} alignment="center" />
                <Column dataField="user_name" selectedFilterOperation={"contains"} caption={t("Email")} alignment="center" />
                <Column dataField="IsActive" selectedFilterOperation={"contains"} caption={t("Aktif")} alignment="center" />
                <Column caption={t("İşlem")}
                    allowSorting={false}
                    cellRender={settingsCell}
                    width={150}
                    alignment="center"

                />
                <Summary>
                    <TotalItem
                        column="full_name"
                        summaryType="count"
                        customizeText={(e) => `${t("Toplam")}: ${formatMoney(e.value, "0", ",")}`}
                    />
                </Summary>
            </DatagridCustom>
            <EmployeeUpdateModal modalUpdate={modalUpdate} setModalUpdate={setModalUpdate} employeeId={selectedUserId} employeeDetail={employeeDetail} trigger={trigger} setTrigger={setTrigger} />

            <Modal size="lg" isOpen={modalDelete} toggle={() => setModalDelete(!modalDelete)}>
                <ModalHeader toggle={() => setModalDelete(!modalDelete)}>
                    Kayıt Silme Formu
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col lg="12">
                            Kullanıcı kaydını silmek istediğinize emin misiniz ?
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Col lg="12" className="d-flex justify-content-center">
                        <Button style={{ height: "30px" }} className="mr-2" id="deleteButton" disabled={false} onClick={() => { deleteEmployee(selectedUserId); document.getElementById("deleteButton").disabled = true }}>
                            Sil
                        </Button>
                        <Button color="danger" style={{ height: "30px" }} className="ml-2" onClick={() => { setModalDelete(false); document.getElementById("deleteButton").disabled = false }}>
                            İptal
                        </Button>
                    </Col>
                </ModalFooter>
            </Modal>
        </>
    )
}